export default "__VITE_ASSET__ByuSzem8__"